module.exports = __webpack_public_path__ + "img/IOT03.14050014.jpg";